export default {
  filters: {},
  paginationOptions: {},
  bookingResourcesTypes: [],
  bookingResourcesStatuses: []
};
